import { defineStore } from 'pinia'
import type { User } from '@common/types/user'

// 创建用户状态的类型
interface UserState {
  user: User
  isLogin: boolean
  serverTime: string
}

export const useUserStore = defineStore('userStore', {
  state: (): UserState => ({
    isLogin: false,
    user: {
      id: '',
      userId: '',
      nickName: '',
      avatar: '',
      eduIdentity: '',
      phone: '',
      openId: '',
      needOnBoarding: true,
      accountLevel: ''
    },
    serverTime: ''
  }),
  getters: {
    getUser: (state): User => state.user ?? {}
  },
  actions: {
    setUser(user: User) {
      this.user = user
      if (user.travelTime) {
        this.setServerTime(user.travelTime)
      }
    },
    setIsLogin(isLogin: boolean) {
      this.isLogin = isLogin
    },
    setKey<K extends keyof User>(key: K, value: User[K]) {
      this.user[key] = value
    },
    getKey<K extends keyof User>(key: K): User[K] {
      return this.user[key]
    },
    setServerTime(time: string) {
      this.serverTime = time
    },
    clearUser() {
      Object.assign(this.user ?? {}, {
        id: '',
        userId: '',
        nickName: '',
        avatar: '',
        eduIdentity: '',
        phone: '',
        openId: '',
        needOnBoarding: false,
        accountLevel: ''
      })
      this.serverTime = ''
    },
    isCreator() {
      const tags = this.user?.accountLevel || ''
      return tags.includes('officialQualityCreator')
    }
  },
  persist: {
    storage: localStorage,
    paths: ['user.needOnBoarding']
  }
})
